"use client";

import { c as _c } from "react/compiler-runtime";
import { useContext, useEffect, useState } from "react";
import { ApiProfileProxy } from "@/generated/models/ApiProfileProxy";
import { ApiProfileProxyAction } from "@/generated/models/ApiProfileProxyAction";
import { AuthContext } from "@/components/auth/Auth";
import PencilIcon, { PencilIconSize } from "@/components/utils/icons/PencilIcon";
import { formatNumberWithCommas } from "@/helpers/Helpers";
export default function ProfileProxyCredit(t0) {
  const $ = _c(19);
  const {
    profileProxy,
    profileProxyAction,
    onCreditEdit
  } = t0;
  const {
    connectedProfile
  } = useContext(AuthContext);
  let t1;
  if ($[0] !== connectedProfile || $[1] !== profileProxy) {
    t1 = () => {
      if (!connectedProfile) {
        return false;
      }
      return connectedProfile?.id === profileProxy.created_by.id;
    };
    $[0] = connectedProfile;
    $[1] = profileProxy;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const getIsOwner = t1;
  const [isOwner, setIsOwner] = useState(getIsOwner());
  let t2;
  if ($[3] !== getIsOwner) {
    t2 = () => setIsOwner(getIsOwner());
    $[3] = getIsOwner;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== connectedProfile || $[6] !== profileProxy) {
    t3 = [connectedProfile, profileProxy];
    $[5] = connectedProfile;
    $[6] = profileProxy;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  useEffect(t2, t3);
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="tw-font-normal tw-text-iron-500">Credit:</span>;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = profileProxyAction.credit_amount ?? 0;
  let t6;
  if ($[9] !== t5) {
    t6 = formatNumberWithCommas(t5);
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t6) {
    t7 = <p className="tw-flex tw-items-center tw-mb-0 tw-gap-x-1.5 tw-text-md tw-font-normal tw-text-iron-500">{t4}<span className="tw-text-iron-300 tw-font-medium">{t6}</span></p>;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== isOwner || $[14] !== onCreditEdit) {
    t8 = isOwner && <button type="button" aria-label="Edit credit" className="tw-group tw-bg-transparent tw-border-0 tw-h-7 tw-w-7 tw-flex tw-items-center tw-justify-center tw-rounded-full tw-text-iron-300 hover:tw-text-iron-400 tw-transition tw-duration-300 tw-ease-out" onClick={onCreditEdit}><PencilIcon size={PencilIconSize.SMALL} /></button>;
    $[13] = isOwner;
    $[14] = onCreditEdit;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t7 || $[17] !== t8) {
    t9 = <div className="tw-flex lg:tw-justify-center tw-items-center">{t7}{t8}</div>;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
}